import React from 'react';

interface AnalyticsHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const AnalyticsHeader: React.FC<AnalyticsHeaderProps> = ({
  title,
  description,
  actions,
  className,
}) => {
  return (
    <header className={`flex items-center justify-between ${className ?? ''}`}>
      <div>
        <h1 className="text-3xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
          {title}
        </h1>
        {description ? (
          <p className="text-muted-foreground mt-2">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-col gap-2">{actions}</div> : null}
    </header>
  );
};
